import { T } from '~/components/I18n/Translation';
import { EmeraldZone1 } from '~/components/Icon/Land/EmeraldZone1';
import { EmeraldZone2 } from '~/components/Icon/Land/EmeraldZone2';
import { EmeraldZone3 } from '~/components/Icon/Land/EmeraldZone3';
import { GoldenZone1 } from '~/components/Icon/Land/GoldenZone1';
import { GoldenZone2 } from '~/components/Icon/Land/GoldenZone2';
import { GoldenZone3 } from '~/components/Icon/Land/GoldenZone3';
import { SapphireZone1 } from '~/components/Icon/Land/SapphireZone1';
import { SapphireZone2 } from '~/components/Icon/Land/SapphireZone2';
import { SapphireZone3 } from '~/components/Icon/Land/SapphireZone3';
import emerald from '~/components/Style/emerald.png';
import golden from '~/components/Style/golden.png';
import sapphire from '~/components/Style/sapphire.png';

// landMeta description has no usage
export const landMeta = {
  EMERALD_ORBIT: {
    title: <T name="citizen_land_title_lv2" />,
    description: <T name="citizen_land_desc_lv2" />,
    citizenNftLevel: 2,
    image: emerald,
  },
  SAPPHIRE_STARLIGHT: {
    title: <T name="citizen_land_title_lv3" />,
    description: <T name="citizen_land_desc_lv3" />,
    citizenNftLevel: 3,
    image: sapphire,
  },
  GOLDEN_GALAXY: {
    title: <T name="citizen_land_title_lv4" />,
    description: <T name="citizen_land_desc_lv4" />,
    citizenNftLevel: 4,
    image: golden,
  },
} as const;

export const zoneImageMap: Record<string, React.ElementType> = {
  level2_zone1: EmeraldZone1,
  level2_zone2: EmeraldZone2,
  level2_zone3: EmeraldZone3,
  level3_zone1: SapphireZone1,
  level3_zone2: SapphireZone2,
  level3_zone3: SapphireZone3,
  level4_zone1: GoldenZone1,
  level4_zone2: GoldenZone2,
  level4_zone3: GoldenZone3,
};
